export const TREES = {
  brands: {
    tag: 'brand',
    wikidataTag: 'brand:wikidata',
    fallbackIcon: 'https://cdn.jsdelivr.net/npm/@mapbox/maki@6/icons/shop-15.svg',
  },
  flags: {
    tag: 'flag:name',
    wikidataTag: 'flag:wikidata',
    fallbackIcon: 'https://cdn.jsdelivr.net/npm/@mapbox/maki@6/icons/embassy-15.svg',
  },
  operators: {
    tag: 'operator',
    wikidataTag: 'operator:wikidata',
    fallbackIcon: 'https://cdn.jsdelivr.net/npm/@rapideditor/temaki@5/icons/briefcase.svg',
  },
  transit: {
    tag: 'network',
    wikidataTag: 'network:wikidata',
    fallbackIcon: 'https://cdn.jsdelivr.net/npm/@rapideditor/temaki@5/icons/board_transit.svg',
  },
};
